module.exports = __webpack_public_path__ + "media/img/pages/companies/careerplus_fr-2f5e6a586efc8cc1cc3bfd6c026b70d4.png";